import UpdateProductRequest from "../payload/request/UpdateProductRequest";
import ProductImageResponse from "../payload/response/ProductImageResponse";
import ProductResponse from "../payload/response/ProductResponse";
import ServiceResponse from "../payload/response/ServiceResponse";
import apiClient from "./apiClient";

export type ProductSearchSortParams = {
  name?: string;
  activeSubstance?: string;
  manufacturerId?: number;
  categoryId?: number;
  sortField?: string;
  sortDirection?: string;
  isActive?: boolean;
};

export const createProduct = async (
  data: FormData
): Promise<ServiceResponse<ProductResponse>> => {
  const response = await apiClient.post<ServiceResponse<ProductResponse>>(
    "/api/product/create-product",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const getProducts = async (
  pageNumber: number,
  pageSize: number,
  params?: ProductSearchSortParams
): Promise<ServiceResponse<ProductResponse>> => {
  const requestBody = {
    pageSize,
    pageNumber,
    ...(params?.name && { name: params.name }),
    ...(params?.activeSubstance && { activeSubstance: params.activeSubstance }),
    ...(params?.manufacturerId && { manufacturerId: params.manufacturerId }),
    ...(params?.categoryId && { categoryId: params.categoryId }),
    ...(params?.sortField && { sortField: params.sortField }),
    ...(params?.sortDirection && { sortDirection: params.sortDirection }),
    ...(params?.isActive !== undefined && { isActive: params.isActive }),
  };

  const response = await apiClient.post<ServiceResponse<ProductResponse>>(
    `/api/product/products/${pageNumber}`,
    requestBody,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
export const getProduct = async (
  id: number
): Promise<ServiceResponse<ProductResponse>> => {
  const response = await apiClient.get<ServiceResponse<ProductResponse>>(
    `/api/product/${id}`
  );
  return response.data;
};
export const getProductImage = async (imageName: string): Promise<Blob> => {
  const response = await apiClient.get(`${imageName}`, {
    responseType: "blob",
  });
  return response.data;
};
export const addProductImage = async (
  data: FormData
): Promise<ServiceResponse<ProductImageResponse>> => {
  const response = await apiClient.post<ServiceResponse<ProductImageResponse>>(
    `/api/product/add-product-image/${data.get("productId")}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const deleteProductImage = async (
  imageId: number
): Promise<ServiceResponse<ProductImageResponse>> => {
  const response = await apiClient.delete<
    ServiceResponse<ProductImageResponse>
  >(`/api/product/delete-product-image/${imageId}`);
  return response.data;
};
export const updateProductStatus = async (
  id: number
): Promise<ServiceResponse<ProductResponse>> => {
  const response = await apiClient.put<ServiceResponse<ProductResponse>>(
    `/api/product/update-product-status/${id}`
  );
  return response.data;
};
export const updateProduct = async (
  data: UpdateProductRequest
): Promise<ServiceResponse<ProductResponse>> => {
  const response = await apiClient.put<ServiceResponse<ProductResponse>>(
    `/api/product/update-product`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
